import { isEqual } from 'lodash';
import { FC, Fragment } from 'react';
import { PiTrashDuotone } from 'react-icons/pi';
import { Button } from 'rizzui';
import CustomTextDelayInput from '../../../../components/forms/CustomTextDelayInput';
import DateField from '../../../../components/forms/DateField';
import { FilterOptions } from '../../../../hooks/useFilters';

interface ICallRecordsFiltersProps {
    updateFilters: (filters: any) => void
    resetFilters: (limit: any) => void
    filters: FilterOptions
}

const CallRecordsFilters: FC<ICallRecordsFiltersProps> = ({ filters, updateFilters, resetFilters }) => {

    return (
        <Fragment>
            <CustomTextDelayInput
                id="search_text"
                label="Buscar"
                filters={filters}
                updateFilters={updateFilters}
            />

            <DateField
                isClearable
                className="w-full"
                label="Fecha de registro"
                placeholderText="Selecciona las fechas"
                selectedDateField={"received_at"}
                startDate={filters.filter_filters?.received_at?.startDate ? new Date(filters.filter_filters.received_at.startDate) : null}
                endDate={filters.filter_filters?.received_at?.endDate ? new Date(filters.filter_filters.received_at.endDate) : null}
                onChange={(date: any) => {
                    const filters_received_at = filters.filter_filters?.received_at;
                    const received_at = date ? { startDate: date[0], endDate: date[1] } : null;
                    if (received_at && !isEqual(filters_received_at, received_at)) {
                        updateFilters({ received_at: { startDate: date[0], endDate: date[1] } });
                    } else if (!received_at && filters_received_at) {
                        updateFilters({ received_at: null });
                    }
                }}
            />

            <Button
                size="sm"
                onClick={() => {
                    resetFilters(50);
                }}
                variant="flat"
                className="h-9 bg-gray-200/70"
            >
                <PiTrashDuotone className="me-1.5 h-[17px] w-[17px]" /> Limpiar
            </Button>
        </Fragment>
    )
}

export default CallRecordsFilters;